<template>
  <div class="mine_right flex_item">
    <div class="mine_rightTop">
      <div class="flex">
        <span class="mine_line"></span>
        <p class="flex_item">个人信息</p>
        <button v-if="!isEditing" @click="isEditing = true" class="bj_btn">
          编辑
        </button>
        <button v-if="isEditing" @click="saveUserInfo" class="bj_btn">
          保存
        </button>
      </div>
    </div>
    <div class="mine_rightBody" id="oForm">
      <div class="flex mine_rightLi">
        <label>头像</label>
        <img :src="userInfo.avatar" class="mine_rightLiTx" alt="" />
      </div>
      <div class="flex mine_rightLi">
        <label>真实姓名</label>
        <p class="mine_rightVal">{{ userInfo.nickName }}</p>
      </div>
      <div v-if="userInfo.userName != null" class="flex mine_rightLi">
        <label>账号</label>
        <p class="mine_rightVal xxkd">{{ userInfo.userName }}</p>
      </div>
      <div class="flex mine_rightLi">
        <label>手机号</label>
        <p class="mine_rightVal xxkd">{{ userInfo.phonenumber }}</p>
      </div>
      <div class="flex mine_rightLi">
        <label>工作单位</label>
        <p v-if="!isEditing" class="mine_rightVal">{{ userInfo.deptName }}</p>
        <input type="text" v-model="myDeptName" id="address" class="mine_rightIpt" v-if="isEditing" />
      </div>
      <div class="flex mine_rightLi">
        <label>任教学段</label>
        <p v-if="!isEditing" class="mine_rightVal">
          {{ userInfo.dictMap?.classroomPeriod }}
        </p>
        <div v-if="isEditing" class="mine_rightSelect">
          <select v-model="myPeriod">
            <option v-for="(period, index) of periodOptions" :key="index" :value="period.title">
              {{ period.title }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex mine_rightLi">
        <label>任教学科</label>
        <p v-if="!isEditing" class="mine_rightVal">
          {{ userInfo.dictMap?.classroomSubject }}
        </p>
        <div v-if="isEditing" class="mine_rightSelect">
          <select v-model="mySubject">
            <option v-for="(subject, index) of subjectOptions" :key="index" :value="subject.title">
              {{ subject.title }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex mine_rightLi top">
        <label>岗层（多选）</label>
        <p v-if="!isEditing" class="mine_rightVal">
          {{ userInfo.dictMap?.classroomHillock }}
        </p>
        <div v-if="isEditing" class="gc_box flex">
          <span v-for="(hillock, index) of hillockOptions" :key="index" class="gc_item"
            :class="hillockIsSelected(hillock.title) ? 'active' : ''" @click="updateHillockStatus(hillock.title)">
            {{ hillock.title }}
          </span>
        </div>
      </div>
      <div class="flex mine_rightLi">
        <label>邮箱</label>
        <p v-if="!isEditing" class="mine_rightVal">{{ userInfo.email }}</p>
        <input type="text" v-model="myEmail" id="email" class="mine_rightIpt" v-if="isEditing" />
      </div>
    </div>
  </div>
</template>

<script>
import { getRegisterInfo } from "../../server/register_info";
import { updateUserInfo } from "../../server/user_center_info";

export default {
  data() {
    return {
      isEditing: false,
      selections: {},
      myPeriod: "",
      mySubject: "",
      myHillock: [],
      myDeptName: "",
      myEmail: "",
    };
  },
  mounted() {
    this.fetchRegisterInfo();
  },
  methods: {
    async fetchRegisterInfo() {
      let result = await getRegisterInfo();
      this.selections = result;
      // 记录当前选中的学段
      if (this.userInfo.dictMap?.classroomPeriod != null) {
        for (const period of this.periodOptions) {
          if (period.title == this.userInfo.dictMap?.classroomPeriod) {
            this.myPeriod = period.title;
            break;
          }
        }
      }
      // 记录当前选中的学科
      if (this.userInfo.dictMap?.classroomSubject != null) {
        for (const subject of this.subjectOptions) {
          if (subject.title == this.userInfo.dictMap?.classroomSubject) {
            this.mySubject = subject.title;
            break;
          }
        }
      }
      // 记录当前选中的岗层
      if (this.userInfo.dictMap?.classroomHillock != null) {
        this.myHillock = [];
        for (const hillock of this.hillockOptions) {
          if (
            this.userInfo.dictMap?.classroomHillock.indexOf(hillock.title) >= 0
          ) {
            this.myHillock.push(hillock.title);
          }
        }
      }
      // 记录工作单位
      this.myDeptName = this.userInfo.deptName;
      // 记录Email
      this.myEmail = this.userInfo.email;
    },
    hillockIsSelected(h) {
      for (const hillock of this.myHillock) {
        if (hillock == h) {
          return true;
        }
      }
      return false;
    },
    updateHillockStatus(h) {
      let isSelected = false;
      for (const hillock of this.myHillock) {
        if (hillock == h) {
          // 当前已选中
          isSelected = true;
          break;
        }
      }
      // 更新选中状态
      if (isSelected) {
        this.myHillock = this.myHillock.filter((hInArray) => hInArray != h);
      } else {
        this.myHillock.push(h);
      }
    },
    async saveUserInfo() {
      // 保存用户信息
      this.userInfo.email = this.myEmail;
      this.userInfo.deptName = this.myDeptName;
      this.userInfo.dictMap.classroomPeriod = this.myPeriod;
      this.userInfo.dictMap.classroomSubject = this.mySubject;
      let hillockStr = "";
      for (const hillock of this.myHillock) {
        hillockStr += `${hillock},`
      }
      if (hillockStr != "" && hillockStr.endsWith(',')) {
        hillockStr = hillockStr.substring(0, hillockStr.length - 1);
      }
      this.userInfo.dictMap.classroomHillock = hillockStr;
      // 修改用户信息
      let params = {
        userId: this.userInfo.userId, //用户id
        workName: this.myDeptName, //工作单位
        classroomPeriod: this.myPeriod, //学段
        classroomSubject: this.mySubject, //学科
        classroomHillocks: hillockStr, //岗层（多个岗层用,号拼接）
        email: this.myEmail //邮箱
      }
      let result = await updateUserInfo(params)
      if (result != false) {
        alert("修改成功");
        this.isEditing = false;
      }
    }
  },
  computed: {
    userInfo: {
      get() {
        return this.$store.getters.userInfo;
      },
      set(newValue) {
        this.$store.commit("updateUserCenterInfo", newValue);
      },
    },
    // 学段选项
    periodOptions() {
      return this.selections.period != null ? this.selections.period : [];
    },
    // 学科选项
    subjectOptions() {
      return this.selections.subject != null ? this.selections.subject : [];
    },
    // 岗层选项
    hillockOptions() {
      return this.selections.hillock != null ? this.selections.hillock : [];
    },
  },
};
</script>

<style scoped>
.mine_right {
  /* min-height: 684px; */
  box-sizing: border-box;
  margin-top: 16px;
}

.mine_rightTop {
  padding: 24px 32px;
  border-bottom: 1px solid #f3f3f3;
  background-color: #fff;
}

.bj_btn {
  font-size: 16px;
  font-weight: 400;
  color: #003399;
  background-color: white;
  padding: 7px 20px;
  border: 1px solid #003399;
  border-radius: 4px;
}

.mine_line {
  width: 5px;
  height: 28px;
  background-color: #003399;
  border-radius: 3px;
  margin-right: 20px;
}

.mine_rightTop p {
  font-size: 28px;
  font-weight: 600;
  color: #222;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.mine_rightBody {
  padding: 16px 32px 32px 32px;
  background-color: #fff;
}

.mine_rightLi {
  margin-top: 34px;
}

.mine_rightLi.top {
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.mine_rightIpt {
  padding: 10px 16px;
  border: 0;
  outline: 0;
  background-color: transparent;
  border: 1px solid #eff3f2;
  width: 247px;
  box-sizing: border-box;
  position: relative;
}

.mine_rightLi label {
  font-size: 14px;
  color: #222;
  line-height: 20px;
  font-weight: 400;
  text-align: right;
  margin-right: 42px;
  width: 100px;
  justify-content: end;
}

.mine_rightLiTx {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.mine_rightVal {
  font-size: 14px;
  color: #222;
  font-weight: 400;
  text-align: left;
  line-height: 20px;
}

.xxmm {
  color: #003399;
  font-size: 14px;
  font-size: 14px;
}

.g_icon_xl {
  width: 14px;
  height: 14px;
}

.mine_rightVal.xxkd {
  width: 200px;
}

.mine_rightSelect select {
  padding: 13px 15px;
  width: 240px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #d4d9e2;
  margin-top: 12px;
}

.mine_rightSelect select option {
  min-height: 50px;
  line-height: 50px;
  color: #222;
  display: inline-block;
}

.xk_down {
  width: 100%;
  cursor: pointer;
}

.dn {
  display: none;
}

.rjxk {
  position: absolute;
  top: 43px;
  left: 0px;
  right: 0px;
  background-color: #fff;
  border: 1px solid #eff3f2;
  border-top: 0px;
  max-height: 240px;
  overflow-y: scroll;
  display: none;
  z-index: 22;
}

.rjxk_item {
  padding: 10px 20px;
  cursor: pointer;
}

.rjxk_item:hover {
  color: #003399;
  background-color: #eff1f7;
}

.gc_box {
  flex-wrap: wrap;
  max-width: 550px;
}

.gc_item {
  width: 118px;
  height: 40px;
  border: 1px solid #eff3f2;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  font-size: 14px;
  color: #222;
  margin-right: 24px;
  margin-top: 24px;
}

.gc_item {
  width: 118px;
  height: 40px;
  border: 1px solid #eff3f2;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  font-size: 14px;
  color: #222;
  margin-right: 24px;
  margin-top: 24px;
}

.gc_item:nth-child(1),
.gc_item:nth-child(2),
.gc_item:nth-child(3),
.gc_item:nth-child(4) {
  margin-top: 0px;
}

.gc_item:nth-child(4n) {
  margin-right: 0px;
}

.gc_item.active {
  border-color: #003399;
  background: url(../../assets/g_icon_gc.png) no-repeat;
  background-size: 28px 24px;
  background-position: right bottom;
}
</style>